import React from 'react';

function FormError({ children }) {
  return (
    <div className="text-[12px] text-red-500 text-center font-normal py-2">
      {children}
    </div>
  );
}

export default FormError;
